// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/**
 * The macOS desktop window has no title bar (lib/platform.ts `overlayTitleBar`), so parts of
 * the page move the window: bare areas marked as drag regions. Tauri drags only when the
 * press lands on the marked element itself, so buttons and links inside one still work.
 */
import { overlayTitleBar } from "../lib/platform.js";

/** Spread on an element whose bare area should move the window (and zoom it on double-click). */
export const dragRegion: { "data-tauri-drag-region"?: "" } = overlayTitleBar ? { "data-tauri-drag-region": "" } : {};

/** A strip along the top of a page without its own header, to move the window by. */
export function WindowDragStrip() {
  if (!overlayTitleBar) return null;
  return <div aria-hidden="true" data-tauri-drag-region="" className="fixed inset-x-0 top-0 h-9" />;
}
